import React from 'react';
import ReactDOM from 'react-dom';
import i18next from 'i18next';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { setBasepath } from 'hookrouter';

import App from './App';
import { getBasePath, getLanguage } from './lib/environment';


setBasepath(getBasePath());

i18next.init({
  lng: getLanguage(),
  resources: Object.assign({},
    require('./resources/i18n/en.js').default,
    require('./resources/i18n/fr.js').default
  )
}).then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

